// @flow

import { beginRequest, completeRequest } from "@store/utils";

import type { EmployeeSmsNotificationsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get Employee Sms Settings

export const onDeleteManagerSmsNotificationSmsRule = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);
export const onDeleteManagerSmsNotificationSmsRuleSuccess = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);
export const onDeleteManagerSmsNotificationSmsRuleError = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);

export const onAddManagerSmsNotificationSmsRule = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);
export const onAddManagerSmsNotificationSmsRuleSuccess = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);
export const onAddManagerSmsNotificationSmsRuleError = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);

export const onUpdateManagerSmsNotificationSmsRule = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);
export const onUpdateManagerSmsNotificationSmsRuleSuccess = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);
export const onUpdateManagerSmsNotificationSmsRuleError = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);

export const onUpdateManagerSmsNotificationSettings = (
  state: EmployeeSmsNotificationsState,
) => () => startRequest(state);
export const onUpdateManagerSmsNotificationSettingsSuccess = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);
export const onUpdateManagerSmsNotificationSettingsError = (
  state: EmployeeSmsNotificationsState,
) => () => finishRequest(state);

export const onAddEmployeeSmsRule = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);
export const onAddEmployeeSmsRuleSuccess = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);
export const onAddEmployeeSmsRuleError = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);
export const onDeleteEmployeeSmsRule = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);

export const onDeleteEmployeeSmsRuleSuccess = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);

export const onDeleteEmployeeSmsRuleError = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);

export const onUpdateEmployeeSmsRule = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);

export const onUpdateEmployeeSmsRuleSuccess = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);

export const onUpdateEmployeeSmsRuleError = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);

export const onUpdateEmployeeSmsSettings = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);

export const onUpdateEmployeeSmsSettingsSuccess = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);

export const onUpdateEmployeeSmsSettingsError = (state: EmployeeSmsNotificationsState) => () =>
  finishRequest(state);

export const onGetEmployeeSmsSettings = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);

export const onGetEmployeeSmsSettingsSuccess = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  settings: payload,
});

export const onGetEmployeeSmsSettingsError = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Employee Sms Rules

export const onGetEmployeeSmsRules = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);

export const onGetEmployeeSmsRulesSuccess = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  smsRules: payload,
});

export const onGetEmployeeSmsRulesError = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Employee Sms Schema

export const onSetEmployeeSmsSchema = (state: EmployeeSmsNotificationsState) => () =>
  startRequest(state);

export const onGetEmployeeSmsSchemaSuccess = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onSetEmployeeSmsSchemaError = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create Employee Sms Notifications

export const onSetEmployeeSmsCurrent = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  current: payload,
});

export const onSetEmployeeSmsAssignments = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  assignments: payload,
});

// Modals

export const onSetShowAddModal = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowDeleteModal = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteModal: payload,
  },
});

export const onGetEmployeeSmsAssignmentsSuccess = (state: EmployeeSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  assignments: payload,
});
